import { LocationSource } from '../realtime/contracts';
import type { LocationSource as PortalLocationSource } from '../realtime/contracts';

export type PositionSource = 'manual' | 'mobileApp' | 'mobileAppSms' | 'webApp' | 'appleEed' | 'aml' | 'googleEls';

export function positionSourceLabelKey(locationSource: PortalLocationSource): string {
  switch (toUiLocationSource(locationSource)) {
    case 'manual':
      return 'PositionSource_Manual_Label';
    case 'mobileApp':
      return 'PositionSource_MobileApp_Label';
    case 'mobileAppSms':
      return 'PositionSource_MobileAppSms_Label';
    case 'webApp':
      return 'PositionSource_WebApp_Label';
    case 'appleEed':
      return 'PositionSource_AppleEed_Label';
    case 'aml':
      return 'PositionSource_Aml_Label';
    case 'googleEls':
      return 'PositionSource_GoogleEls_Label';
  }
}

export function toUiLocationSource(locationSource: PortalLocationSource): PositionSource {
  switch (locationSource) {
    case LocationSource.Entered:
      return 'manual';
    case LocationSource.MobileApp:
      return 'mobileApp';
    case LocationSource.MobileAppSms:
      return 'mobileAppSms';
    case LocationSource.WebApp:
      return 'webApp';
    case LocationSource.AppleEed:
      return 'appleEed';
    case LocationSource.Aml:
      return 'aml';
    case LocationSource.GoogleEls:
      return 'googleEls';
  }
}
